class History {
  constructor() {
    this.prev = '';
    this.pageTypes = ['product', 'blog', 'collection', 'page', 'search'];
    this._init();
  }

  _init() {
    this.url = window.location.href;
    this.evaluateUrl();
  }

  evaluateUrl() {
    const pageIsInRange = this.pageTypes.some((type) =>
      this.url.includes(type)
    );

    if (!pageIsInRange) {
      sessionStorage.removeItem('history-previous-url');
      return;
    }

    this.pageTypes.forEach((type) => {
      const prevUrl = sessionStorage.getItem('history-previous-url');

      if (type === 'search' && prevUrl) {
        this.prev = prevUrl;
        return type;
      } else if (this.url.includes(type)) {
        this.prev = this.url;
        sessionStorage.setItem('history-previous-url', this.prev);
        return type;
      }
    });
  }
}

export { History };
